import { Upload } from "@progress/kendo-react-upload";
import { useEffect, useState } from "react";
import FileUploadService from "../../services/srv-fileUpload/FileUploadService";
import LoadingPanel from "../sys-toolbox/LoadingPanel";
import {
  API_GATEWAY,
  CDN_PROJECT_NAME,
  MS_SENDER,
} from "../../config/globalVariables";
import { Button } from "@progress/kendo-react-buttons";
import { trashIcon, downloadIcon } from "@progress/kendo-svg-icons";

export const CommonUploadFiles = ({
  batch,
  multiple,
  disabled,
  withCredentials,
  tableName,
  tableId,
  fileType,
}) => {
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getFiles();
  }, []);

  const getFiles = () => {
    FileUploadService.getFiles(tableName, tableId, fileType, callback);
  };

  const callback = (data) => {
    if (data) {
      setFiles(data);
    }

    setIsLoading(false);
  };

  const downloadFile = (cdn_file) => {
    setIsLoading(true);
    FileUploadService.downloadFile(cdn_file, callback);
  };

  const onAdd = (event) => {
    setFiles(event.newState);
  };

  const onRemove = (fileId, tableName, fileType, tableId) => {
    setIsLoading(true);
    FileUploadService.deleteFile(
      fileId,
      tableName,
      tableId,
      fileType,
      callback
    );
  };

  const onProgress = (event) => {
    setFiles(event.newState);
  };

  const onUploadSuccess = (uid, event) => {
    getFiles();
  };

  const onStatusChange = (event) => {
    setFiles(event.newState);
    getFiles();
  };

  const fileIconClass = (extension) => {
    switch (extension) {
      case ".csv":
      case ".xlsx":
      case ".xls":
        return "k-i-file-data";
      case ".png":
      case ".jpeg":
        return "k-i-file-image";
      case ".pdf":
        return "k-i-file-pdf";
      case ".txt":
      default:
        return "k-i-file-txt";
    }
  };

  const listItem = (props) => {
    return (
      <>
        {props.files?.map((file) => {
          return (
            <div className="k-file-single" key={file.name}>
              <span className="k-file-group-wrapper">
                <span
                  className={`k-file-group k-icon ${fileIconClass(
                    file.extension
                  )}`}
                ></span>
                <span className="k-file-state"></span>
              </span>
              <span className="k-file-name-size-wrapper">
                <span className="k-file-name" title={file.name}>
                  {file.name}
                </span>
                <span className="k-file-validation-message"></span>
              </span>
              <strong className="k-upload-status">
                <Button
                  title="Download"
                  onClick={() => downloadFile(file.cdnFileId)}
                  svgIcon={downloadIcon}
                  fillMode={"flat"}
                />
                <Button
                  title="Remove"
                  onClick={() =>
                    onRemove(file.fileId, tableName, fileType, tableId)
                  }
                  svgIcon={trashIcon}
                  fillMode={"flat"}
                />
              </strong>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <div>
      {isLoading && <LoadingPanel />}
      <Upload
        batch={batch ? batch : false}
        multiple={multiple ? multiple : true}
        disabled={disabled}
        files={files}
        onAdd={onAdd}
        onRemove={onRemove}
        onProgress={onProgress}
        onUploadSuccess={onUploadSuccess}
        onStatusChange={onStatusChange}
        listItemUI={listItem}
        withCredentials={withCredentials ? withCredentials : false}
        saveHeaders={{
          Authorization: "Bearer " + localStorage.getItem("jwtToken"),
        }}
        removeHeaders={{
          Authorization: "Bearer " + localStorage.getItem("jwtToken"),
        }}
        saveUrl={`${
          API_GATEWAY + MS_SENDER
        }/file/add/${CDN_PROJECT_NAME}/${tableName}/${tableId}/${fileType}`}
        removeUrl={(event) => {
          var fileId = files.find((f) => f.uid === event[0].uid).fileId;
          return `${
            API_GATEWAY + MS_SENDER
          }/file/delete/${CDN_PROJECT_NAME}/${fileId}`;
        }}
      />
    </div>
  );
};

// const mapStateToProps = (state) => {
//   return {
//     auth: state.authReducer,
//   };
// };

// export default connect(mapStateToProps)(CommonUploadFiles);
